import { render, staticRenderFns } from "./shangchuan.vue?vue&type=template&id=198c1d08&"
import script from "./shangchuan.vue?vue&type=script&lang=js&"
export * from "./shangchuan.vue?vue&type=script&lang=js&"
import style0 from "./shangchuan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports